import * as IconSelector from '../icons';

// Constantes exportadas
export const TYPE_QUOTA_COMPLETA = 'Cuota completa';
export const TYPE_QUOTA_PARCIAL = 'Cuota parcial';
export const TYPE_QUOTA_YA_EMITIDA = 'Cuota ya emitida';

// Definición del enum
export const typeQuota = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: TYPE_QUOTA_COMPLETA,
        label: 'Cuota completa',
        description: 'Se genera la cuota completa',
        icon: IconSelector.FullIcon,
        color: 'Green'
    },
    {
        value: TYPE_QUOTA_PARCIAL,
        label: 'Cuota parcial',
        description: 'Se genera la cuota por la declaración',
        icon: IconSelector.PartialIcon,
        color: 'DarkOrange'
    },
    {
        value: TYPE_QUOTA_YA_EMITIDA,
        label: 'Cuota ya emitida',
        description: 'La cuota se emitió en una declaración anterior',
        icon: IconSelector.DoneIcon,
        color: 'Red'
    }
];
